import React from 'react';
import './ResetMeetingConfirm.css';

const ResetMeetingConfirm = ({ isOpen, onClose, onConfirm, meetingName }) => {
  if (!isOpen) return null;

  return (
    <div className="reset-confirm-overlay">
      <div className="reset-confirm-modal">
        <div className="reset-confirm-header">
          <h2>Reset Meeting Data</h2>
          <button className="close-button" onClick={onClose}>
            <i className="ti ti-x"></i>
          </button>
        </div>
        
        <div className="reset-confirm-content">
          <div className="warning-icon">
            <i className="ti ti-alert-triangle"></i>
          </div>
          
          <h3>Are you sure you want to reset this meeting?</h3>
          
          <p className="meeting-name">
            <strong>{meetingName || 'Untitled Meeting'}</strong>
          </p>
          
          <div className="warning-message">
            <p>This action will permanently delete all previously saved data including:</p>
            <ul>
              <li>Transcripts</li>
              <li>Objectives statuses</li>
              <li>Questions and answers</li>
              <li>Coaching points</li>
              <li>Wrap-up items</li>
              <li>Follow-ups</li>
            </ul>
            <p><strong>This action cannot be undone.</strong></p>
          </div>
        </div>
        
        <div className="reset-confirm-actions">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button className="reset-button" onClick={onConfirm}>
            Reset Meeting Data
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetMeetingConfirm; 